<div class="login-page">
  <mat-card>
    <mat-card-title style="text-align:center;">Nueva contraseña</mat-card-title>
    <mat-card-content>
      <p>Introduzca su nueva contraseña</p>
      <form [formGroup]="loginForm">
        <mat-form-field appearance="outline" class='formField'>
          <mat-label>Contraseña</mat-label>
          <input matInput placeholder="Contraseña" formControlName="loginPassword" type="password" required>
          <mat-error>La contraseña es obligatoria</mat-error>
          <mat-error>Mínimo 8 caracteres</mat-error>
          <mat-icon matSuffix color="primary" >lock</mat-icon>
        </mat-form-field>
        <mat-form-field appearance="outline" class='formField'>
          <mat-label>Repite la contraseña</mat-label>
          <input matInput placeholder="Repite la contraseña" formControlName="loginPassword2" type="password" required>
          <mat-error>La contraseña es obligatoria</mat-error>
          <mat-error>Mínimo 8 caracteres</mat-error>
          <mat-icon matSuffix color="primary" >lock</mat-icon>
        </mat-form-field>
      </form>
      <button mat-raised-button color="primary" class="login-button" (click)="changePassword()"> Cambiar contraseña</button>
      <div class='actionBlock pointer' routerLink="/login">¡Ya tengo cuenta!</div>
    </mat-card-content>
    @if (loading) {
      <div class='spinner'>
        <mat-spinner></mat-spinner>
      </div>
    }
  </mat-card>
</div>
